import { TCustomerField } from 'modules/checkout/domain/entities';

export type TVectisMissingFieldProfile = 'CLIENTE' | 'RESPONSAVEL';

export interface IVectisMissingCustomerField {
  perfil: TVectisMissingFieldProfile;
  campo: string;
}

const FIELD_BY_PROFILE: Record<
  TVectisMissingFieldProfile,
  Partial<Record<string, TCustomerField>>
> = {
  CLIENTE: {
    dataNascimento: 'birthdate',
    email: 'email',
    cpf: 'document',
    numeroRg: 'rgDocument',
    numeroDocumentoFiscal: 'taxDocument',
    foneCelular: 'phone',
    numeroCep: 'address.postalCode',
    idCidade: 'address.city.id',
    idBairro: 'address.district.id',
    logradouro: 'address.street',
    numeroLogradouro: 'address.number',
  },
  RESPONSAVEL: {
    nome: 'guardian.firstName',
    sobrenome: 'guardian.lastName',
    dataNascimento: 'guardian.birthdate',
    cpf: 'guardian.document',
    numeroRg: 'guardian.rgDocument',
    numeroDocumentoFiscal: 'guardian.taxDocument',
    foneCelular: 'guardian.phone',
    numeroCep: 'guardian.address.postalCode',
    idCidade: 'guardian.address.city.id',
    idBairro: 'guardian.address.district.id',
    logradouro: 'guardian.address.street',
    numeroLogradouro: 'guardian.address.number',
  },
};

export function buildMissingCustomerFields(
  vectisFields?: IVectisMissingCustomerField[] | null,
): TCustomerField[] {
  if (!Array.isArray(vectisFields)) return [];

  const fields = vectisFields
    .map(({ perfil, campo }) => FIELD_BY_PROFILE[perfil]?.[campo])
    .filter((field): field is TCustomerField => !!field);

  return Array.from(new Set(fields));
}
